export default __webpack_public_path__ + "static/logo-45af50d8a8cf54e4f32191dce1ce3e77.png";